/* Buy Now Button */

const checkoutUrl = document.querySelector('#buy-now-url').value;
const buyNowBtn = document.querySelectorAll('#buy-now-btn');

const $this = $(this);

function returnToURL(addBtn,colorError) {
    if (addBtn.data('enabled') && !colorError){
        setTimeout(()=> {
            location.href = checkoutUrl
        }, 500)
    }
}
buyNowBtn.forEach(e => e.addEventListener('click', function () {
    const addBtn = $('.add-to-cart-btn');
    
    const colors = document.querySelectorAll(".color-attribute");

    let colorError = true, sizeError = true;
    colors.forEach((item, index) => {
        const colorSwatch = item.querySelector("span");
        if (colorSwatch.classList.contains("selected")){
            colorError = false;
        }
    });

    if ($('.grid-talla-btn').length){

        if ($('#buy-now-btn').data('enabled') && $('.grid-talla-btn').find('button.selected').length){
            returnToURL(addBtn,colorError);
        } 
    }
    else{
        returnToURL(addBtn,colorError);
    }

})) 

$('.vertical-carousel .gallery div').on('click', function() {

    const $this = $(this);
    $this.siblings().removeClass('active');
    $this.addClass('active');
    const $img = $this.find('img');
    $('.product-active-img').attr('src', $img.attr('src'));
});

const btnColor = document.querySelectorAll(".grid-color-btn .color-attribute");
console.log(btnColor);
if (btnColor.length === 2) {
    setTimeout(() => {
        $('.color-attribute').trigger("click");
    }, 1000);  
}


/// STOCK Validation UI

const handleWatchObserver = (element, type) => {
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if(mutation.type == "childList"){
            }
            if (mutation.type == "attributes"){

                if (mutation.target.localName == "span") {
                    const $button = $(mutation.target).parent();
                    const $this = $(mutation.target)
                    $button.removeClass(type + '-button-unselectable')
                    $button.removeClass(type + '-button-selectable')
                    if ($this.hasClass('unselectable')){

                        $button.addClass(type + '-button-unselectable')
                    } else {
                    }
                }
            }
        });
    });
    
    observer.observe(element, {
        attributes: true, //configure it to listen to attribute changes
        childList: true,
        subtree: true 
    });
}

const sizeElements = $('.grid-talla-btn .talla-attribute span')
sizeElements.map(function (i, el) {
    const element = $(el)[0]
    handleWatchObserver(element, 'talla')  
})

const colorElements = $('.swatchCont .color-attribute span')
colorElements.map(function (i, el) {
    const element = $(el)[0]
    handleWatchObserver(element, 'color')  
})
